// Preserve page state only when a healthy route consumes/changes its query.
// Explicit re-entry and navigation state (Home/Gym/Log modes) keep remount semantics.
export function nextPageRecoveryIdentity(previous, location) {
  if (!previous) return { location, key: location.key }
  if (previous.location.key === location.key) return previous
  const before = previous.location
  const queryOnly = before.pathname === location.pathname
    && before.hash === location.hash
    && before.state === location.state
    && before.search !== location.search
  return { location, key: queryOnly ? previous.key : location.key }
}
